import type { MessageKey } from './en';

export const zhCN: Record<MessageKey, string> = {
  appName: 'TrueAlpha',
  github: 'GitHub',
  privacyShort: '仅本地处理',
  privacyTitle: '文件始终留在此设备',
  privacyBody: 'TrueAlpha 只在浏览器内存中分析图片，不会上传文件，也不会调用远程分析服务。',
  language: '语言',
  languageEnglish: 'EN',
  languageChinese: '简体中文',
  switchToChinese: '切换到简体中文',
  switchToEnglish: '切换到英文',
  theme: '主题',
  lightTheme: '使用浅色主题',
  darkTheme: '使用深色主题',
  title: '你的 PNG 真的透明吗？',
  subtitle: '无需上传文件，直接检查 Alpha 像素。',
  addFiles: '添加 PNG 文件',
  chooseFiles: '选择 PNG 文件',
  dropTitle: '将 PNG 文件拖到这里',
  dropBody: '或从设备中选择文件',
  dropHint: '仅支持 PNG。单个文件不超过 25 MB，每批最多 100 个。',
  fileInputLabel: '选择一个或多个 PNG 文件',
  validationInvalidType: '{name} 不是 PNG 文件。',
  validationTooLarge: '{name} 超过 25 MB 限制。',
  validationDuplicate: '{name} 已经在当前批次中。',
  validationBatchLimit: '本批次只能再添加 {count} 个文件，上限为 100 个。',
  validationNothingAdded: '没有添加任何文件。',
  addedFiles: '已添加 {count} 个文件并开始本地分析。',
  dismissed: '关闭消息',
  notifications: '通知',
  primaryNavigation: '主导航',
  reportExport: '报告导出',
  batchActions: '批量操作',
  batchSummary: '批量摘要',
  summaryTotal: '总数',
  summaryAnalyzed: '已分析',
  summaryTransparent: '真实 Alpha',
  summaryOpaque: '不透明',
  summarySuspected: '疑似风险',
  summaryErrors: '错误',
  summaryInProgress: '进行中',
  results: '检测结果',
  resultCount: '{count} 个结果',
  searchLabel: '搜索文件',
  searchPlaceholder: '按文件名搜索',
  filterLabel: '按状态筛选',
  filterAll: '全部状态',
  filterReady: '已分析',
  filterTransparent: '真实透明',
  filterOpaque: '完全不透明',
  filterSuspected: '疑似背景',
  filterProgress: '进行中',
  filterError: '错误',
  sortLabel: '结果排序',
  sortAdded: '添加顺序',
  sortName: '文件名',
  sortTransparentDesc: '透明比例：从高到低',
  sortTransparentAsc: '透明比例：从低到高',
  selectAll: '选择全部可见结果',
  selectedCount: '已选择 {count} 个',
  deleteSelected: '删除所选',
  reanalyzeSelected: '重新检测所选',
  clearAll: '清空全部',
  exportJson: '导出 JSON',
  exportCsv: '导出 CSV',
  exportNothing: '请先完成至少一个文件的分析再导出报告。',
  tablePreview: '预览',
  tableFile: '文件',
  tableSize: '尺寸和大小',
  tableAlpha: '真实透明',
  tableTransparent: '完全透明',
  tableSemi: '半透明',
  tablePadding: '透明边距',
  tableRisk: '疑似背景',
  tableStatus: '状态',
  tableActions: '操作',
  selectFile: '选择 {name}',
  openDetails: '打开 {name} 的详情',
  deleteFile: '删除 {name}',
  reanalyzeFile: '重新检测 {name}',
  unknownDimensions: '等待读取尺寸',
  notAvailable: '不可用',
  yes: '是',
  no: '否',
  none: '无',
  pixels: 'px',
  paddingValues: '上 {top} 右 {right} 下 {bottom} 左 {left}',
  statusQueued: '等待中',
  statusAnalyzing: '正在分析',
  statusReady: '分析完成',
  statusError: '分析失败',
  statusTransparent: '真实透明',
  statusOpaque: '完全不透明',
  statusSuspected: '疑似',
  loadingFile: '正在分析 {name}',
  loadingProgress: '已完成 {progress}%',
  emptyTitle: '当前批次没有 PNG 文件',
  emptyBody: '在上方添加文件，即可检查结构、Alpha 像素、边缘和透明边距。',
  emptyFilteredTitle: '没有符合筛选条件的结果',
  emptyFilteredBody: '修改搜索内容或状态筛选即可查看更多文件。',
  details: '文件详情',
  noSelectionTitle: '选择一个结果查看详情',
  noSelectionBody: '这里将显示预览、Alpha 统计、检测结果和裁切控制。',
  preview: '预览',
  previewAlt: '{name} 的预览',
  background: '预览背景',
  backgroundWhite: '白色',
  backgroundBlack: '黑色',
  backgroundGray: '中灰色',
  backgroundRed: '红色',
  backgroundGreen: '绿色',
  backgroundBlue: '蓝色',
  backgroundChecker: '棋盘格',
  fit: '适应窗口',
  actualSize: '100%',
  previewScale: '预览缩放',
  zoomControls: '缩放控制',
  zoomOut: '缩小',
  zoomIn: '放大',
  showBoundingBox: '内容边界框',
  showMarginGuides: '透明边距辅助线',
  bboxUnavailable: '当前没有可用的非透明内容边界框。',
  imageDimensions: '图片尺寸',
  fileSize: '文件大小',
  analyzedAt: '分析时间',
  duration: '耗时',
  alphaStatistics: 'Alpha 统计',
  totalPixels: '总像素',
  fullyTransparent: '完全透明',
  semiTransparent: '半透明',
  fullyOpaque: '完全不透明',
  minAlpha: '最小 Alpha',
  maxAlpha: '最大 Alpha',
  averageAlpha: '平均 Alpha',
  edgeCoverage: '边缘不透明占比',
  transparentPadding: '透明边距',
  pngStructure: 'PNG 结构',
  bitDepth: '位深度',
  colorType: '颜色类型',
  trnsChunk: 'tRNS 数据块',
  alphaSupport: 'Alpha 支持',
  findings: '检测结果',
  noFindings: '分析器没有生成检测标签。',
  findingRealTransparency: '存在真实透明度',
  findingFullTransparencyPresent: '存在完全透明像素',
  findingAlphaChannelUnused: 'Alpha 通道未使用',
  findingFullyOpaque: '完全不透明',
  findingSemiTransparentPixels: '存在半透明像素',
  findingEdgeContent: '内容触及图片边缘',
  findingTransparentPadding: '存在透明边距',
  findingSuspectedSolidBackground: '疑似纯色背景',
  findingSuspectedCheckerboard: '疑似烘焙棋盘格',
  findingCleanAsset: '素材状态干净',
  reasonSuspectedSolidBackground: '不透明边缘和四角样本由一种低方差颜色主导。',
  reasonSuspectedCheckerboard: '边缘两种不透明颜色呈现水平和垂直棋盘状周期。',
  confidence: '置信度 {value}%',
  heuristicTitle: '启发式结果',
  heuristicDisclaimer: '疑似背景和棋盘格属于启发式判断，可能存在误报。',
  semiDisclaimer: '半透明像素常用于抗锯齿、阴影和柔和边缘，不一定是错误。',
  trimTitle: '裁切透明空白',
  trimMargin: '保留边距',
  trimButton: '下载裁切后的 PNG',
  trimWorking: '正在生成 PNG',
  trimReady: '原文件不会被修改。',
  trimNoPadding: '此图片没有可移除的透明空白。',
  trimNoContent: '无法找到可安全裁切的内容边界框。',
  trimPending: '请等待分析完成后再裁切。',
  trimError: '无法生成裁切后的 PNG。',
  trimSuccess: '已生成保留 {margin} px 边距的 PNG。',
  detectionGuide: '检测说明',
  guideRealTitle: '真实透明',
  guideRealBody: '至少一个解码像素的 Alpha 值小于 255。',
  guideUnusedTitle: '未使用的 Alpha 通道',
  guideUnusedBody: 'PNG 结构支持 Alpha，但所有解码像素都完全不透明。',
  guideSolidTitle: '疑似纯色背景',
  guideSolidBody: '不透明边缘和角落具有低方差的主要颜色，但这不能证明背景已烘焙。',
  guideCheckerTitle: '疑似烘焙棋盘格',
  guideCheckerBody: '图片边缘发现重复的交替颜色，带图案的素材也可能触发此判断。',
  guidePaddingTitle: '透明边距',
  guidePaddingBody: '非透明内容边界框周围存在可移除的透明空间。',
  localFooter: '所有分析均在浏览器本地运行。',
  sourceFooter: '在 GitHub 上查看源码',
  unexpectedError: '界面发生了意外错误。',
};
